"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPT_IN_TYPES = exports.LISTING_TYPE_TO_COLLOQUIAL_NAME = exports.LISTING_TYPES = exports.LISTING_CONNECTION_FLOWS = void 0;
var LISTING_TYPES = exports.LISTING_TYPES = Object.freeze({
  ACONCT: 'ACONCT',
  ADVISR: 'ADVISR',
  COCPAP: 'COCPAP'
});
var LISTING_TYPE_TO_COLLOQUIAL_NAME = exports.LISTING_TYPE_TO_COLLOQUIAL_NAME = Object.freeze({
  ACONCT: 'Enroll',
  ADVISR: 'Inquire',
  COCPAP: 'Connect'
});
var LISTING_CONNECTION_FLOWS = exports.LISTING_CONNECTION_FLOWS = Object.freeze({
  AUTOCONFLOW: 'AUTOCONFLOW'
});
var OPT_IN_TYPES = exports.OPT_IN_TYPES = Object.freeze({
  ADMIN: 'ADMIN',
  USER: 'USER'
});